import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { LoginInfo } from './../../models';
import { Alert } from 'selenium-webdriver';

@Component({
  selector: 'app-introduction-videos',
  templateUrl: './introduction-videos.component.html',
  styleUrls: ['./introduction-videos.component.scss']
})
export class IntroductionVideosComponent implements OnInit {
  routingPath: string;
  userDetail: Partial<LoginInfo>;
  videoList: any = [];
  selectedVideo = { contentTitle: '', contentHtml: '' };
  partnerData: any = [];
  @ViewChild('modal') modelVal;
  constructor(private router: Router,
     private routes: ActivatedRoute, 
     private commonRequestResponseService: CommonRequestResponseService, 
     private _commonAuthenticationService: CommonAuthenticationService) { }

  ngOnInit() {
    this.partnerData = JSON.parse(localStorage.getItem('partnerDetail'));
    this.getIntroContent();
  }

  onCompleteProfile() {
    this.routingPath = `../${this._commonAuthenticationService.getModule()}/${this.userDetail.route}`;
    this.router.navigate([this.routingPath], { relativeTo: this.routes });
  }

  getIntroContent() {
    this.userDetail = this._commonAuthenticationService.getLoginData();
    const inputJson = {
      roleClassId: this.userDetail.roleClassID
    }
    this.commonRequestResponseService.post('admin/newUserContent', inputJson)
      .subscribe((response: any) => {
        this.videoList = response.items[0];
      },
      (error) => console.error(error)
      )
  }

  openVideoPopup(videoObject) {
    this.selectedVideo = videoObject;
    this.modelVal.show();
  }

}
